import {Component, OnInit} from '@angular/core';
import {ArticlesService} from "../articles.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-view-article',
  templateUrl: './view-article.component.html',
  styleUrls: ['./view-article.component.css']
})
export class ViewArticleComponent implements OnInit{

  networkState:number=0;
  errorMsg:string | null = null;

  articlesService:ArticlesService;
  // @ts-ignore
  articleId:string|null;

  article:any;

  constructor(_articlesService: ArticlesService, private route: ActivatedRoute) {
    this.articlesService = _articlesService;
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.articleId = params.get('id');
    });

    this.getArticle();
  }

  getArticle(){
    this.networkState = 0;
    this.errorMsg = null;

    this.articlesService.getArticle(this.articleId)
      .subscribe({
        next: (res) => {

          this.article = {...res};

          this.networkState = 1;

        },
        error: (error) => {
          this.errorMsg = error.message;
          this.networkState = 2;

        }
      });
  }

}
